module.exports = __webpack_public_path__ + "img/jinrong-bg-3.0afc2f5d.png";